import { gql } from '@apollo/client';

export const SEND_CLIP_TO_PROCESS = gql`
  mutation ProcessClip($testSessionNoteId: ID!) {
    processClip(testSessionNoteId: $testSessionNoteId) {
      testSessionNoteId
    }
  }
`;
